<template>
  <div class="main">
    <a-carousel ref="carousel" v-if="!loading" :autoplay="false" :infinite="false" :afterChange="after_change">
      <div>
        <div class="head">
          <div class="title">{{ stname }}</div>
        </div>
        <div class="top-info">
          <!-- <img class="logo" src="https://oss.mcloud.moveclub.cn/mcloudbkh5/20220922/1663854657-632c68419f022.png" /> -->
          <div class="date fx-led">
            <div class="time">{{ date.date }}</div>
            <div class="week">{{ date.week }}</div>
            <div class="time">{{ date.time }}</div>
          </div>
          <div class="notice-bar">
            <img src="../../assets/gonghui/notice.png" />
            <div class="con">
              <div class="text" v-if="notice && notice.content" :style="{ transform: `translateX(${0}px)` }">
                {{ notice.content }}
              </div>
              <div class="text" v-else :style="{ transform: `translateX(${0}px)` }">
                在踏上运动征程之前，请先为身体热身；在追求健康的旅途中，请时刻珍惜安全航行。
              </div>
            </div>
          </div>
          <div class="right">
            <div class="type">
              <img src="../../assets/gonghui/type.png" />
              <div class="label">{{ store.typeName }} {{ store.stypeName ? '| ' + store.stypeName : '' }} | 职工驿站</div>
            </div>
            <div class="switch">轮播模式：<a-switch v-model="autoplay" checked-children="开" un-checked-children="关" /></div>
          </div>
        </div>
        <div class="body">
          <div class="left">
            <div class="top">
              <div class="ltop">
                <div class="item">
                  <div class="name">今日运动</div>
                  <div class="val">
                    <div class="fx-led">{{ today_user }}</div>
                    <div class="unit">人</div>
                  </div>
                </div>
                <div class="item">
                  <div class="name">累计运动</div>
                  <div class="val">
                    <div class="fx-led">{{ all_user }}</div>
                    <div class="unit">人</div>
                  </div>
                </div>
                <div class="item">
                  <div class="name">参与工会</div>
                  <div class="val">
                    <div class="fx-led">{{ company_num }}</div>
                    <!-- <div class="fx-led">{{ 30 }}</div> -->
                    <div class="unit">家</div>
                  </div>
                </div>
              </div>
              <div class="c-title">驿站设备</div>
              <left-middle v-if="devices && devices.length" :list="devices"></left-middle>
            </div>
            <div class="l-middle">
              <div class="c-title">
                <div>职工体质综合评级</div>
                <!-- <div class="right">
                  <div class="item color-1">合格人数</div>
                  <div class="item color-2">不合格人数</div>
                  <div class="item none">% 为合格率</div>
                </div> -->
              </div>
              <!-- <left-top v-if="advice && advice.length" :physical="advice"></left-top> -->
              <right-top v-if="level && level.length" :dongbi="level"></right-top>
            </div>
          </div>
          <div class="middle">
            <div class="top">
              <middle-top :source-data="physical"></middle-top>
            </div>
            <div class="bottom">
              <!-- <div class="c-title">排名</div> -->
              <div class="b-left b-card">
                <div class="c-title">驿站健身</div>
                <middle-bottom :count="5" v-if="peopleRank && peopleRank.length" :list1="peopleRank" :list2="peopleRankOrg"></middle-bottom>
              </div>
              <div class="b-right b-card">
                <div class="c-title">线上活动</div>
                <middle-bottom-copy
                  :count="5"
                  v-if="zryGroupRank_r && zryGroupRank_r.length"
                  :list1="zryGroupRank_r"
                  :list2="zryGroupRank_z"
                  :list3="zryGroupRank_y"
                ></middle-bottom-copy>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="top">
              <div class="c-title">健康服务</div>
              <left-bottom v-if="distributionData && distributionData.list.length" :list="distributionData"></left-bottom>
            </div>
            <div class="r-middle">
              <div class="c-title">主题活动</div>
              <right-bottom v-if="activityData && activityData.length" :list1="activityData" :list2="activityDataOrg"></right-bottom>
            </div>
          </div>
        </div>
      </div>
      <div class="map-area">
        <gh-map></gh-map>
      </div>
      <div class="img-body" v-if="store.layout">
        <img :src="store.layout" />
      </div>
      <template v-if="video_url_2.length">
        <div class="img-body" v-for="(item, index) in video_url_2" :key="index">
          <video class="video" :ref="'video' + (index + 1)" :src="item"></video>
        </div>
      </template>
    </a-carousel>
  </div>
</template>

<script>
import leftTop from './left-top.vue'
import leftMiddle from './left-middle.vue'
import leftBottom from './left-bottom.vue'
import rightTop from './right-top.vue'
import rightBottom from './right-bottom.vue'
import middleTop from './middle-top.vue'
import middleBottom from './middle-bottom.vue'
import middleBottomCopy from './middle-bottom-copy.vue'
import ghMap from '../../components/map.vue'

import api from '@/api'
import moment from 'moment'

let itimer = null
let ctimer = null
let dtimer = null

function isElementInViewport(el) {
  //获取元素是否在可视区域
  var rect = el.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

export default {
  components: {
    ghMap,
    leftTop,
    leftMiddle,
    leftBottom,
    rightTop,
    rightBottom,
    middleBottom,
    middleTop,
    middleBottomCopy,
  },
  computed: {
    week_width() {
      if (this.week_user == 0) {
        return 12
      } else {
        if (this.week_user > this.last_week_user) {
          return 80
        } else {
          return 80 * (this.week_user / this.last_week_user)
        }
      }
    },
    last_week_width() {
      if (this.last_week_user == 0) {
        return 12
      } else {
        if (this.week_user < this.last_week_user) {
          return 80
        } else {
          return 80 * (this.last_week_user / this.week_user)
        }
      }
    },
  },
  data() {
    return {
      date: {},
      time: this.$route.query.time * 1000 || 60000,
      autoplay: false,
      loading: true,

      // left
      company: 0,
      company_num: 0,
      online_user: 0,
      reg_user: 0,
      people_flow: null,
      notice: {
        content: '',
        title: '',
      },

      // middle
      total_device: 0,
      devices: [],
      peopleRank: [],
      companyRank: [],
      distributionData: {},

      // right
      dongbi: [],
      physical: [],
      stname: '虹口区879园区健身驿站',

      store: {},
      video_url: '',
      video_url_2: '',

      zryGroupRank_r: [],
      zryGroupRank_y: [],
      zryGroupRank_z: [],
      peopleRankCalories: [],

      // new
      advice: [],
      all_user: 0,
      last_week_user: 0,
      today_user: 0,
      week_chain: 0,
      week_user: 0,
      level: [],
    }
  },
  mounted() {
    this.get_data()

    itimer = setInterval(() => {
      this.get_data()
    }, 60000)

    ctimer = setTimeout(() => {
      if (this.autoplay) {
        this.$refs.carousel.next()
      }
    }, this.time)
  },
  beforeDestroy() {
    clearInterval(itimer)
  },
  methods: {
    after_change(i) {
      clearTimeout(ctimer)

      let el_list = window.document.querySelectorAll('.video')
      let el = null

      el_list.forEach((element) => {
        console.log(isElementInViewport(element))
        if (isElementInViewport(element)) {
          el = element
        }
      })

      if (el) {
        const duration = el.duration * 1000

        setTimeout(() => {
          el.load()
          el.play()
        }, 500)

        ctimer = setTimeout(() => {
          if (this.autoplay) {
            this.$refs.carousel.next()
          }
        }, duration)
      } else {
        el_list.forEach((element) => {
          if (isElementInViewport(element)) {
            element.pause()
          }
        })
        ctimer = setTimeout(() => {
          if (this.autoplay) {
            this.$refs.carousel.next()
          }
        }, this.time)
      }
    },
    get_data() {
      // &is_over=1&times=1&game_over=1
      const query = this.$route.query
      api.common.indexData({ ...query, stid: this.$route.query.stid, gid: 'eStBcUhqZ0ZvRE09' }).then((r) => {
        this.date = {
          date: moment(r.sys_time * 1000).format('YYYY-MM-DD'),
          week: moment(r.sys_time * 1000).format('dddd'),
          time: moment(r.sys_time * 1000).format('HH:mm:ss'),
        }

        clearInterval(dtimer)

        dtimer = setInterval(() => {
          let date = this.date.date + ' ' + this.date.time
          this.date = {
            date: moment(date).add(1, 'second').format('YYYY-MM-DD'),
            week: moment(date).add(1, 'second').format('dddd'),
            time: moment(date).add(1, 'second').format('HH:mm:ss'),
          }
        }, 1000)

        Object.keys(r.data).forEach((key) => {
          this[key] = r.data[key]
        })
      })

      api.common.indexDataNew({ ...query, stid: this.$route.query.stid, gid: 'eStBcUhqZ0ZvRE09' }).then((r) => {
        let arr = []

        Object.keys(r.data.level).forEach((key) => {
          const obj = {
            item: key,
            count: r.data.level[key] * 1,
          }

          // if (key == '不合格') {
          //   // obj.item = '待提高'
          //   obj.count = 9
          // }

          // if (key == '优秀') {
          //   obj.count = 30
          // }

          arr.push(obj)
        })

        r.data.level = arr

        arr = []

        Object.keys(r.data.advice).forEach((key) => {
          arr.push({
            item: key,
            count: r.data.advice[key] * 1,
          })
        })

        r.data.advice = arr

        Object.keys(r.data).forEach((key) => {
          this[key] = r.data[key]
        })

        this.loading = false
      })
    },
  },
}
</script>

<style lang="less">
body {
  background: #001f5d;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
.main {
  background: #001f5d;
  min-height: 100vh;
  width: 100vw;
  // padding-bottom: 20px;
  box-sizing: border-box;
  font-size: 0;
  .head {
    width: 100%;
    height: 81px;
    background: url(../../assets/gonghui/head-bg.png) no-repeat top center / 100% 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    .title {
      font-size: 36px;
      color: #ffffff;
      margin-top: 12px;
      text-align: center;
    }
  }
  .top-info {
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .logo {
      position: absolute;
      top: -62px;
      left: 20px;
      width: 62px;
      height: 62px;
      border-radius: 6px;
      overflow: hidden;
    }
    .date {
      color: #fff;
      font-size: 36px;
      display: flex;
      align-items: center;
      .week {
        padding: 0 12px;
        font-size: 26px;
        font-weight: bold;
      }
    }
    .notice-bar {
      position: absolute;
      width: 828px;
      height: 48px;
      background: #003d9e;
      border-radius: 4px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      align-items: center;
      padding: 0 13px;
      img {
        width: 26px;
        height: 26px;
      }
      .con {
        width: 760px;
        height: 25px;
        font-size: 18px;
        color: #a5d4ff;
        font-weight: 600;
        margin-left: 20px;
        overflow: hidden;
        position: relative;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        .text {
          white-space: nowrap;
          position: absolute;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      .type {
        display: flex;
        align-items: center;
        font-size: 15px;
        color: #a5d4ff;
        font-weight: 600;
        img {
          width: 26px;
          height: 26px;
          &.logo {
            width: 48px;
            height: 48px;
            margin-bottom: 2px;
            border-radius: 6px;
            overflow: hidden;
          }
        }
        .label {
          margin-right: 32px;
          margin-left: 12px;
          padding-top: 12px;
        }
      }
      .switch {
        margin-left: 90px;
        font-size: 18px;
        color: #ffffff;
        font-weight: 600;
        display: flex;
        align-items: center;
      }
    }
  }
  .img-body {
    width: 100%;
    height: 100vh;
    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    > video {
      width: 100%;
      height: 100%;
    }
  }
  .body {
    display: flex;
    padding: 0 20px;
    margin-top: 20px;
    .c-title {
      padding-top: 10px;
      font-size: 22px;
      color: #a5d4ff;
      text-align: center;
    }
    .left {
      width: 504px;
      .top {
        width: 504px;
        height: 531px;
        background: url(https://oss.mcloud.moveclub.cn/mcloudbkh5/20220325/1648192948-623d6db435129.png) no-repeat top center/ 100% 100%;
        padding: 20px 28px;
        .ltop {
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-sizing: border-box;
          .item {
            background: #002874;
            width: 144px;
            height: 98px;
            padding: 15px;
            background: #002874;
            border-radius: 4px;
            .name {
              font-size: 18px;
              color: #ffffff;
              opacity: 0.65;
              font-weight: 600;
            }
            .val {
              font-size: 30px;
              color: #ffffff;
              font-weight: 700;
              margin-top: 10px;
              display: flex;
              align-items: baseline;
              justify-content: space-between;
              .unit {
                font-size: 14px;
                color: #ffffff;
                font-weight: 400;
                opacity: 0.65;
              }
            }
          }
        }
        .c-title {
          text-align: left;
          padding: 12px 0px 20px;
          background: url(../../assets/gonghui/left-bottom-line.png) no-repeat bottom center / contain;
        }
      }
      .l-middle {
        width: 504px;
        height: 339px;
        margin-top: 20px;
        background: url(../../assets/gonghui/left-bottom.png) no-repeat top center / 100% 100%;
        padding: 0 30px;
        .c-title {
          text-align: left;
          padding: 12px 0px 20px;
          background: url(../../assets/gonghui/left-bottom-line.png) no-repeat bottom center / contain;
        }
      }
      .bottom {
        margin-top: 32px;
        height: 322px;
        background: url(../../assets/gonghui/left-bottom.png) no-repeat top center / 100% 100%;
      }
    }
    .middle {
      box-sizing: content-box;
      padding: 0 20px;
      width: 868px;
      .top {
        height: 428px;
        background: url(../../assets/gonghui/middle-top.png) no-repeat top center / 100% 100%;
      }
      .bottom {
        margin-top: 20px;
        height: 442px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .b-card {
          box-sizing: border-box;
          width: 416px;
          height: 442px;
          background: url(../../assets/gonghui/middle-bottom.png) no-repeat top center / 100% 100%;
          .c-title {
            text-align: left;
            padding: 12px 0px 20px;
            background: url(../../assets/gonghui/left-bottom-line.png) no-repeat bottom center / contain;
            margin: 0 30px;
          }
        }
      }
    }
    .right {
      width: 504px;
      .top {
        height: 304px;
        background: url(../../assets/gonghui/right-top.png) no-repeat top center / 100% 100%;
        .c-title {
          margin: 0 30px;
          text-align: left;
          padding: 12px 0px;
          background: url(../../assets/gonghui/left-bottom-line.png) no-repeat bottom center / contain;
        }
      }
      .r-middle {
        .c-title {
          margin: 0 30px;
          text-align: left;
          padding: 12px 0px 20px;
          background: url(../../assets/gonghui/left-bottom-line.png) no-repeat bottom center / contain;
        }
        margin-top: 20px;
        height: 562px;
        background: url(../../assets/gonghui/right-middle.png) no-repeat top center / 100% 100%;
      }
    }
  }
}
</style>
